import React from 'react';
import { BandGroupIcon } from '../../icons';
import { PlayButton } from '../../PlayButton/PlayButton';
import { useAudioPlayer } from '../../../contexts/AudioPlayerContext';
import './BandListing.css';

export interface BandListingProps {
  name: string;
  imageUrl?: string;
  soundcloudUrl?: string;
  genres?: string[];
  onClick?: () => void;
}

export const BandListing: React.FC<BandListingProps> = ({
  name,
  imageUrl,
  soundcloudUrl,
  genres,
  onClick,
}) => {
  // Audio player context
  const { state, toggle, getProgress } = useAudioPlayer();

  const isPlaying = soundcloudUrl ? state.currentUrl === soundcloudUrl && state.isPlaying : false;
  const isLoading = soundcloudUrl ? state.currentUrl === soundcloudUrl && state.isLoading : false;
  const progress = soundcloudUrl ? getProgress(soundcloudUrl) : 0;

  const handlePlayClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (soundcloudUrl) {
      toggle(soundcloudUrl);
    }
  };

  // Only show play button if there's a soundcloud URL
  const showPlayButton = !!soundcloudUrl;

  return (
    <div className="band-listing" onClick={onClick}>
      <div className="band-listing__image">
        {imageUrl ? (
          <>
            <div className="band-listing__overlay" />
            <img src={imageUrl} alt="" />
          </>
        ) : (
          <BandGroupIcon size={48} />
        )}
        {showPlayButton && (
          <div className="band-listing__play-button">
            <PlayButton
              size={36}
              isPlaying={isPlaying}
              isLoading={isLoading}
              progress={progress}
              onClick={handlePlayClick}
            />
          </div>
        )}
      </div>
      <div className="band-listing__content">
        <div className="band-listing__name">{name}</div>
        {genres && genres.length > 0 && (
          <div className="band-listing__genres">
            {genres.slice(0, 3).join(' · ')}
          </div>
        )}
      </div>
    </div>
  );
};
